import { capitalizeFirstLetter } from './StringHelpers';

export function mapSimpleVuexProperty(name) {
    const result = {};
    const upperCased = capitalizeFirstLetter(name);
    result[name] = {
        get() {
            return this.$store.getters['appSettings/get' + upperCased];
        },
        set(value) {
            return this.$store.commit('appSettings/set' + upperCased, value);
        },
    };
    return result;
}
